export default "__VITE_ASSET__CTWCp9fC__"